<div class="flex flex-1 flex-row">
	<div class="w-1/2">
		<h2>TARION warranty</h2>
		<div class="mr-5 flex flex-col gap-5">
			<div class="mt-3" *ngIf="closingDate">
				<p>Closing date</p>
				<p class="font-bold">{{ closingDate | date: 'longDate' }}</p>
			</div>

			<app-radio-group
				[items]="creditItems"
				label="Credit"
				name="area"
				[(ngModel)]="adjustment.credit"
				(ngModelChange)="changed()"
				type="compact"
				[ngClass]="{ 'mt-3': !closingDate }"
				[testHook]="testHooks.CreditType"
			></app-radio-group>

			<app-select
				label="Fee rates based on enrolment date"
				[(ngModel)]="adjustment.rateTable"
				(ngModelChange)="changed()"
				[disabled]="adjustment.credit === 'none'"
				[testHook]="testHooks.EnrolmentDateSelect"
			>
				<ng-container *ngFor="let option of enrolmentDateOptions">
					<option
						[value]="option.value"
						[testHook]="testHooks.EnrolmentDateOption"
					>
						{{ option.name }}
					</option>
				</ng-container>
			</app-select>

			<app-select
				label="Fee rates based on"
				[(ngModel)]="adjustment.saleAmount"
				(ngModelChange)="changed()"
				[disabled]="adjustment.credit === 'none'"
				[testHook]="testHooks.FeeRatesSelect"
			>
				<option
					[value]="tarionSaleAmountOptions.AGREED"
					[testHook]="testHooks.AgreedPriceOption"
				>
					Agreed sale price,
					{{ salePriceCalculated.salePrice | centsToDollars }}
				</option>
				<option
					*ngIf="
						salePriceAdjustment.netOutHst !== netOutHstOptions.NO &&
						salePriceAdjustment.netOutHst !==
							netOutHstOptions.NO_SALE_PRICE_HST &&
						salePriceAdjustment.netOutHst !==
							netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
					"
					[value]="tarionSaleAmountOptions.NET"
					[testHook]="testHooks.NetPriceOption"
				>
					Net sale price, {{ salePriceCalculated.nsp | centsToDollars }}
				</option>
				<option
					*ngIf="
						salePriceAdjustment.netOutHst === netOutHstOptions.YES_HST ||
						salePriceAdjustment.netOutHst === netOutHstOptions.YES_HST_NO_REBATE
					"
					[value]="tarionSaleAmountOptions.REBATE"
					[testHook]="testHooks.NetPriceRebateOption"
				>
					Net sale price less HST rebate,
					{{ salePriceCalculated.nspNoRebate | centsToDollars }}
				</option>
				<option
					*ngIf="
						salePriceAdjustment.netOutHst !== netOutHstOptions.NO &&
						salePriceAdjustment.netOutHst !==
							netOutHstOptions.NO_SALE_PRICE_HST &&
						salePriceAdjustment.netOutHst !==
							netOutHstOptions.NO_SALE_PRICE_HST_AND_REBATE
					"
					[value]="tarionSaleAmountOptions.SUM"
					[testHook]="testHooks.SumOption"
				>
					Net sale price {{ salePriceCalculated.nsp | centsToDollars }} plus
					specified sum
				</option>
			</app-select>
			<app-input
				type="cents"
				*ngIf="adjustment.saleAmount === 'sum'"
				label="Specify sum"
				name="sum"
				[(ngModel)]="adjustment.sum"
				(ngModelChange)="changed()"
				[disabled]="adjustment.credit === 'none'"
				[testHook]="testHooks.SumInput"
			></app-input>
			<app-checkbox
				label="Apply HST ({{ hst | percent }})"
				[(ngModel)]="adjustment.applyHst"
				(ngModelChange)="changed()"
				[disabled]="adjustment.credit === 'none'"
				[testHook]="testHooks.HstCheckbox"
			></app-checkbox>
			<app-input
				*ngIf="
					creditAmount > 0 ||
					(creditAmount == 0 && adjustment.credit === 'vendor')
				"
				type="cents"
				label="Credit vendor"
				name="credit"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount"
				[disabled]="true"
				[testHook]="testHooks.VendorCredit"
			></app-input>
			<app-input
				*ngIf="
					creditAmount < 0 ||
					(creditAmount == 0 && adjustment.credit === 'purchaser')
				"
				type="cents"
				label="Credit purchaser"
				name="credit"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="creditAmount * -1"
				[disabled]="true"
				[testHook]="testHooks.PurchaserCredit"
			></app-input>
			<div class="mt-3">
				<app-checkbox
					label="Include all details in document"
					[(ngModel)]="adjustment.details"
					[testHook]="testHooks.IncludeDetailsCheckbox"
				></app-checkbox>
			</div>
		</div>
		<div class="flex justify-between mr-5 mt-5">
			<app-button
				btn="tertiary"
				class="mr-5"
				(click)="cancelModal()"
				[testHook]="testHooks.CancelButton"
				>Cancel</app-button
			>
			<app-button (click)="saveModal()" [testHook]="testHooks.SaveButton"
				>Save</app-button
			>
		</div>
	</div>
	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="mb-8">
					<div *ngIf="adjustment.credit !== 'none'">
						<div class="flex justify-between items-start mb-3">
							<div>Enrolment fee</div>
							<div>{{ enrolmentFee | centsToDollars }}</div>
						</div>
						<div
							[testHook]="testHooks.HstAmount"
							*ngIf="adjustment.applyHst"
							class="flex justify-end items-start mb-8"
						>
							<div>
								<strong
									>HST ({{ hst | percent }}) =
									{{ hstAmount | centsToDollars }}</strong
								>
							</div>
						</div>
						<div class="flex justify-end items-start">
							<div
								*ngIf="
									creditAmount > 0 ||
									(creditAmount == 0 && adjustment.credit === 'vendor')
								"
							>
								<strong
									>Credit Vendor = {{ creditAmount | centsToDollars }}</strong
								>
							</div>
							<div
								*ngIf="
									creditAmount < 0 ||
									(creditAmount == 0 && adjustment.credit === 'purchaser')
								"
							>
								<strong
									>Credit Purchaser =
									{{ creditAmount * -1 | centsToDollars }}</strong
								>
							</div>
						</div>
					</div>
					<div *ngIf="adjustment.credit === 'none'">
						<div class="flex justify-end items-start mb-8">
							<div>No adjustment</div>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
